import React, { FC, ReactElement } from "react";
import { useUserQuery } from "../../../graphql/menu.hooks";
import { Navigate } from "react-router-dom";
import { Spinner } from "react-bootstrap";

interface WithAdminAccessProps {
  children: ReactElement;
}

export const WithAdminAccess: FC<WithAdminAccessProps> = ({ children }) => {
  const { data: user, loading: userLoading } = useUserQuery();

  if (userLoading) {
    return (
      <div className="d-flex align-items-center justify-content-center">
        <Spinner animation="border" role="status"></Spinner>
      </div>
    );
  }

  if (!user?.user.admin) {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
};
